import styled from "styled-components";

export const HomeLoggedStyle = styled.div`
    height: 100vh;
    width: 100%;
    background-color: #E5F8FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const WrapContent = styled.div`
    width: 75%;
    height: 80%;
    display: flex;
    flex-direction: column;
`

export const SesiImage = styled.img`
    width: 200px;
    height: 90px;
    margin: 0;
`

export const WelcomeRow = styled.div`
    display: flex;
    flex-direction: row;
    height: 80px;
    align-items: center;
    gap: 10px;
`

export const ProfilePic = styled.img`
    width: 80px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid #d1d5db;
    margin-left: 15px;
`

export const WrapWelcome = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 10px;

    h1{
        color: #FF5742;
        font-size: 20px;
        font-weight: 900;
        margin: 0;
    }

    h2{
        margin: 0;
        color: #005CA9;
        font-size: 20px;
        font-weight: 500;
    }
`

export const LogoutButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  color: red;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    color: #003f7d;
  }

  svg {
    margin-right: 5px;
  }
`;